<template>
    <div>
        <Form :formVisible="showForm" />
        <DeleteDialog
                title="Delete"
                text="Gebäude wirklich löschen?"
                :deleteMode="deleteMode"
                :confirmCallback="deleteConfirmCallback"
        />
        <!---->
        <el-card class="box-card">
            <div slot="header">
                <span>Gebäude</span>
                <el-button v-if="user_is_admin" style="float: right; padding: 3px 0" type="text" @click="$router.push('/new-building')">Hinzufügen</el-button>
            </div>

            <el-row></el-row>
            <el-row>
                <el-table
                        v-loading="loading"
                        :data="buildings"
                        @row-click="rowClickHandler"
                        style="width: 100%">
                    <el-table-column
                            v-for="(col, index) in tableColumns"
                            :key="index"
                            :label="col.label"
                            :prop="col.prop"
                            align="center"
                            :formatter="col.formatter"
                            :width=getColumnWidth(col)>
                    </el-table-column>

                    <el-table-column label="Modul Informationen" align="center">
                        <el-table-column label="Frei" align="center">
                            <template slot-scope="scope">
                                <el-col align="center">
                                    <el-tag type="success">{{ scope.row.total_available_panels }}</el-tag>
                                </el-col>
                            </template>
                        </el-table-column>
                        <el-table-column label="Total" align="center">
                            <template slot-scope="scope">
                                <el-col align="center">
                                    <el-tag>{{ scope.row.total_panels }}</el-tag>
                                </el-col>
                            </template>
                        </el-table-column>
                    </el-table-column>

                    <el-table-column label="URL" align="center">
                        <template slot-scope="scope">
                            <el-col align="center">
                                <el-link :underline="false" type="primary" target="_blank" :href="getBuildingUrl(scope.row)">{{ sanitizeString(scope.row.address) }}</el-link>
                            </el-col>
                        </template>
                    </el-table-column>

                    <el-table-column
                            align="center"
                            fixed="right"
                            width="120px">
                        <template slot-scope="scope">
                            <el-button
                                @click="handleView(scope.row.id)"
                                type="text"
                                size="small">Ansicht</el-button>
                            <el-button
                                    v-if="user_is_admin"
                                    @click="deleteClickHandler(scope.row.id)"
                                    type="text"
                                    size="small">Löschen</el-button>
                            <!--<DeleteBtn style="margin-left: 1rem" @clicked="deleteClickHandler(scope.row.id)" />-->
                        </template>
                    </el-table-column>

                </el-table>
            </el-row>
        </el-card>

        <el-dialog
            title="Warning"
            :visible.sync="deleteDialogVisible"
            width="30%"
            center>
            <span>It should be noted that the content will not be aligned in center by default</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deleteDialogVisible = false">Abbrechen</el-button>
                <el-button type="primary" @click="deleteDialogVisible = false">Bestätigen</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    /* eslint-disable no-console */

    import { mapGetters } from 'vuex';
    import { FETCH_BUILDINGS, DELETE_BUILDING } from '../../../store/types';
    import Form from './BuildingForm';
    import DeleteDialog from '../../atoms/dialog/Delete';
    import DeleteBtn from '../../atoms/button/DeleteBtn';

    export default {
        name: 'Buildings',
        components: { Form, DeleteDialog, DeleteBtn },
        data () {
            return {
                // buildings: {},
                loading: false,
                showForm: false,
                deleteMode: false,
                deleteBuilding: null,
                deleteDialogVisible: false,
            };
        },
        computed: {
            ...mapGetters(['get_app_url', 'get_suppliers', 'user_is_admin', 'get_buildings', 'get_building']),
            buildings () {
                return this.get_buildings;
            },
            tableColumns () {
                return [
                    { prop: 'id', label: 'ID', width: 80 },
                    { prop: 'street', label: 'Adresse', formatter: row => row.address },
                    { prop: 'number_of_fields', label: 'Anzahl Sektoren' },
                ];
            },
        },
        created () {
            this.getBuildings();
        },
        methods: {
            getBuildings () {
                if (!this.get_buildings || this.get_buildings.length === 1) {
                    this.loading = true;
                    this.$store.dispatch(FETCH_BUILDINGS).then(() => {
                        this.loading = false;
                        // if (this.user_is_admin) {
                        //     this.$store.dispatch(FETCH_SUPPLIERS);
                        // }
                    });
                }
            },
            getColumnWidth (col) {
                return col.width || 'auto';
            },
            handleView (buildingId) {
                this.$router.push(`/buildings/${buildingId}`);
            },
            deleteClickHandler (buildingId) {
                this.deleteMode = true;
                this.deleteBuilding = this.get_building(buildingId);
            },
            deleteConfirmCallback () {
                this.$store.dispatch(DELETE_BUILDING, this.deleteBuilding).then((resp) => {
                    this.deleteMode = false;
                    this.$message.success(resp.message);
                    this.$router.push('/buildings');
                });
            },
            rowClickHandler () {
                // this.$router.push(`/buildings/${row.id}`);
                // if (!e.target.closest('button')) {
                //     e.target.closest('.el-table__row').querySelector('.el-table__expand-icon').click();
                // }
            },
            getBuildingUrl (building) {
                return `${building.supplier.permalink_url}/${this.sanitizeString(building.address)}`;
            },
            sanitizeString (stringToSanitize) {
                // Change to lower case
                let slug = stringToSanitize.toLowerCase();
                // Letter "e"
                slug = slug.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
                // Letter "a"
                slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
                // Letter "o"
                slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
                // Letter "u"
                slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
                // Letter "d"
                slug = slug.replace(/đ/gi, 'd');
                // Trim the last whitespace
                slug = slug.replace(/\s*$/g, '');
                // Change whitespace to "-"
                slug = slug.replace(/\s+/g, '-');
                return slug;
            },
        },
    };
</script>

<style scoped>
    .danger {
        color: #f56c6c;
    }
    .table-header {
        padding-bottom: 1rem;
        border-bottom: 1px solid #0000001a;
    }
    .field-box {
        margin-bottom: 1rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/buildings/Buildings.vue